"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const flora_react_1 = require("@grupoboticario/flora-react");
const SearchBar_styled_1 = require("./SearchBar.styled");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const SearchBar = ({ labelText, onSubmit, value }) => {
    const [inputSearchValue, setInputSearchValue] = (0, react_1.useState)('');
    const handleSubmit = (event) => {
        event.preventDefault();
        onSubmit(inputSearchValue);
    };
    (0, react_1.useEffect)(() => {
        if (value)
            setInputSearchValue(value);
    }, [value]);
    return ((0, jsx_runtime_1.jsx)(SearchBar_styled_1.Form, Object.assign({ onSubmit: handleSubmit }, { children: (0, jsx_runtime_1.jsx)(SearchBar_styled_1.WrapperInput, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Input, { id: "searchBar", value: inputSearchValue, onChange: (event) => setInputSearchValue(event.target.value), labelText: labelText, type: "search", optionalText: "", rightIcon: (0, jsx_runtime_1.jsx)(flora_react_1.IconButton, Object.assign({ css: { fontSize: '0px' }, "data-flora": "button", "data-flora-text": "Buscar", label: "Buscar", "aria-label": "Buscar", "autotagging-flora": "on", type: "submit" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(flora_react_icons_1.MagnifyingGlassIcon, { color: "$nonInteractiveAuxiliar" }), 'Buscar'] }) })) }) }) })));
};
exports.default = SearchBar;
